import React from 'react';
import { Box, Typography } from '@mui/material';

interface EnablementCardProps {
  title: string;
  content: string;
  bgcolor: string;
  padding?: string;
}

const EnablementCard: React.FC<EnablementCardProps> = ({
  title,
  content,
  bgcolor,
  padding = '16px',
}) => (
  <Box sx={{ p: { padding }, borderRadius: '8px', bgcolor }}>
    <Typography
      sx={{
        fontFamily: 'Poppins',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '-0.01em',
        mb: 1,
        color: '#111827',
      }}
    >
      {title}
    </Typography>
    <Typography
      sx={{
        fontFamily: 'Poppins',
        fontWeight: 400,
        fontSize: '15px',
        lineHeight: '20px',
        letterSpacing: '-0.01em',
        color: '#000000',
      }}
    >
      {content}
    </Typography>
  </Box>
);

export default EnablementCard;
